import { Component, ViewChild, effect, input, model, output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Guid } from "moo-shared";
import { BaseComponent } from "../../../shared/base.component";
import { isEmptyString } from "../../../shared/helpers";
import { NotificationBarComponent } from "../../../shared/notification-bar";
import { LoginPictureModel } from "./login-picture.viewmodel";

@Component({
  selector: "app-picture-selection",
  templateUrl: "./picture-selection.component.html",
  styleUrls: ["./picture-selection.component.scss"]
})
export class PictureSelectionComponent extends BaseComponent {
  override componentTranslationRoot = "login.picture-selection";
  availablePictures = input.required<LoginPictureModel[]>();

  notificationMessage = input.required<[string, boolean]>();

  selectedPictureKeys = model<Guid[]>([]);
  stop = output();
  @ViewChild("notificationBar", { static: false }) notificationBar!: NotificationBarComponent;

  constructor(

    translateService: TranslateService
  ) {
    super(translateService);

    effect(() => {
      const message = this.notificationMessage()[0];
      if (!isEmptyString(message)) {
        this.notificationBar.showErrorMessage({
          icon: "icon-meh",
          text: message
        });
      }
    });
  }

  get hasSelectedPictures(): boolean {
    return this.selectedPictureKeys().length > 0;
  }

  get isPictureSelectionAllowed(): boolean {
    return this.selectedPictureKeys().length < 3;
  }

  addPictureToSelection(pictureKey: Guid) {
    if (this.isPictureSelectionAllowed) {
      this.notificationBar.hide();
      this.selectedPictureKeys.set([...this.selectedPictureKeys(), pictureKey]);
    }
  }

  removePicture() {
    this.selectedPictureKeys.set([...this.selectedPictureKeys().slice(0, -1)]);
  }

  hasSelectedNeededAmount(neededAmount: number): boolean {
    return this.selectedPictureKeys().length >= neededAmount;
  }

  emitStop() {
    this.stop.emit();
  }
}
